import { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs, doc, getDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const CATEGORY_ICONS = {
  'Fuel & Gas': <svg viewBox="0 0 24 24" width="20" height="20" fill="#0D9488"><path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 0 0 5 0V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5z"/></svg>,
  'Vehicle Maintenance': <svg viewBox="0 0 24 24" width="20" height="20" fill="#06B6D4"><path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/></svg>,
  'Insurance': <svg viewBox="0 0 24 24" width="20" height="20" fill="#14B8A6"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>,
  'Tolls & Parking': <svg viewBox="0 0 24 24" width="20" height="20" fill="#34D399"><path d="M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"/></svg>,
  'Phone & Data': <svg viewBox="0 0 24 24" width="20" height="20" fill="#38BDF8"><path d="M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"/></svg>,
  'Meals & Entertainment': <svg viewBox="0 0 24 24" width="20" height="20" fill="#FBBF24"><path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/></svg>,
  'Office Supplies': <svg viewBox="0 0 24 24" width="20" height="20" fill="#94A3B8"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"/></svg>,
  'Software & Subscriptions': <svg viewBox="0 0 24 24" width="20" height="20" fill="#06B6D4"><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/></svg>,
  'Professional Services': <svg viewBox="0 0 24 24" width="20" height="20" fill="#14B8A6"><path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/></svg>,
  'Travel & Lodging': <svg viewBox="0 0 24 24" width="20" height="20" fill="#0D9488"><path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"/></svg>,
  'Equipment & Tools': <svg viewBox="0 0 24 24" width="20" height="20" fill="#34D399"><path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/></svg>,
  'Other': <svg viewBox="0 0 24 24" width="20" height="20" fill="#64748B"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zM13 9V3.5L18.5 9H13z"/></svg>,
};

export default function Expenses() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState(null);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    async function fetchData() {
      try {
        // Check subscription
        const userSnap = await getDoc(doc(db, 'users', currentUser.uid));
        if (userSnap.exists()) {
          setSubscription(userSnap.data().subscription || {});
        }

        // Fetch expenses
        const expensesRef = collection(db, 'users', currentUser.uid, 'expenses');
        const q = query(expensesRef, orderBy('date', 'desc'));
        const snapshot = await getDocs(q);
        setExpenses(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (err) {
        console.error('Error fetching expenses:', err);
      }
      setLoading(false);
    }
    fetchData();
  }, [currentUser.uid]);

  async function handleDelete(expenseId) {
    if (!window.confirm('Delete this expense?')) return;
    await deleteDoc(doc(db, 'users', currentUser.uid, 'expenses', expenseId));
    setExpenses((prev) => prev.filter((e) => e.id !== expenseId));
  }

  const isSubscribed = subscription?.status === 'active' || subscription?.status === 'trialing';

  if (!isSubscribed) {
    return (
      <div className="screen-container">
        <h2>Expenses</h2>
        <div className="pro-gate">
          <div className="pro-gate-icon">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="#0D9488">
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
            </svg>
          </div>
          <h3>Subscribe to MileDeduct</h3>
          <p>Start your free trial to unlock expense tracking, receipt scanning, and all features.</p>
          <button className="btn btn-primary" onClick={() => navigate('/subscription')}>
            Start Free Trial
          </button>
        </div>
      </div>
    );
  }

  const filtered = filter === 'all' ? expenses : expenses.filter((e) => e.category === filter);
  const totalExpenses = filtered.reduce((sum, e) => sum + (e.total || 0), 0);
  const categories = [...new Set(expenses.map((e) => e.category))];

  return (
    <div className="screen-container">
      <div className="expenses-header">
        <h2>Expenses</h2>
        <button className="btn btn-primary expense-add-btn" onClick={() => navigate('/expenses/add')}>
          + Add Expense
        </button>
      </div>

      {/* Summary */}
      <div className="expense-summary">
        <div className="summary-card">
          <span className="summary-value">${totalExpenses.toFixed(2)}</span>
          <span className="summary-label">Total</span>
        </div>
        <div className="summary-card">
          <span className="summary-value">{filtered.length}</span>
          <span className="summary-label">Expenses</span>
        </div>
        <div className="summary-card">
          <span className="summary-value">{categories.length}</span>
          <span className="summary-label">Categories</span>
        </div>
      </div>

      {/* Category Filter */}
      {categories.length > 0 && (
        <div className="expense-filters">
          <button
            className={`filter-chip ${filter === 'all' ? 'selected' : ''}`}
            onClick={() => setFilter('all')}
          >
            All
          </button>
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-chip ${filter === cat ? 'selected' : ''}`}
              onClick={() => setFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

      {/* Expense List */}
      {loading ? (
        <div className="loading">Loading expenses...</div>
      ) : expenses.length === 0 ? (
        <div className="empty-state">
          <h3>No expenses yet</h3>
          <p>Scan a receipt or add an expense manually to get started.</p>
        </div>
      ) : (
        <div className="expense-list">
          {filtered.map((exp) => (
            <div key={exp.id} className="expense-card">
              <div className="expense-card-icon">
                {CATEGORY_ICONS[exp.category] || '📄'}
              </div>
              <div className="expense-card-details">
                <span className="expense-merchant">{exp.merchant || 'Unknown'}</span>
                <span className="expense-meta">
                  {new Date(exp.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                  {' · '}{exp.category}
                </span>
              </div>
              <div className="expense-card-amount">
                ${exp.total?.toFixed(2)}
              </div>
              <button className="expense-delete" onClick={() => handleDelete(exp.id)}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                </svg>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
